import { IProcessedStyleSet, IStyle, ILinkStyles, mergeStyleSets } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../common.styles';

export interface LoadingPageStyles {
  progressContainer: IStyle;
  cancelLinkContainer: IStyle;
  imageContainer: IStyle;
  labelContainer: IStyle;
}

export const getCancelLinkStyles = (): ILinkStyles => {
  return AppLayoutSettings.AppCommonStyles.getLinkStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().linkColor);
};

export const getLoadingPageStyles = (): IProcessedStyleSet<LoadingPageStyles> => {
  const styles: LoadingPageStyles = {
    progressContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      width: '100%'
    },
    cancelLinkContainer: {
      marginTop: '8px',
      width: '100%'
    },
    imageContainer: {
      marginTop: '66px',
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    labelContainer: {
      width: '100%'
    }
  };

  return mergeStyleSets(styles);
};

export function getStatusLabelContainerStyle() {
  return {
    display: 'flex',
    justifyContent:'space-between'
  };
}
